import { render, staticRenderFns } from "./SearchSvg.vue?vue&type=template&id=27ad4843&"
var script = {}
import style0 from "./SearchSvg.vue?vue&type=style&index=0&id=27ad4843&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports